import { render, staticRenderFns } from "./participateTestOwn.vue?vue&type=template&id=54d742bd&scoped=true"
import script from "./participateTestOwn.vue?vue&type=script&lang=js"
export * from "./participateTestOwn.vue?vue&type=script&lang=js"
import style0 from "./participateTestOwn.vue?vue&type=style&index=0&id=54d742bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d742bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d742bd')) {
      api.createRecord('54d742bd', component.options)
    } else {
      api.reload('54d742bd', component.options)
    }
    module.hot.accept("./participateTestOwn.vue?vue&type=template&id=54d742bd&scoped=true", function () {
      api.rerender('54d742bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/participateTestOwn/participateTestOwn.vue"
export default component.exports